import React, { PureComponent } from 'react'

const withAlertTimeout = ComposedComponent =>
  class extends PureComponent {
    constructor(props) {
      super(props)
      this.state = {
        success: false,
        failure: false
      }

      this.showSuccess = this.showSuccess.bind(this)
      this.showFailure = this.showFailure.bind(this)
    }

    showSuccess() {
      this.setState({ success: true })
      setTimeout(() => {
        this.setState({ success: false })
      }, 3000)
    }

    showFailure() {
      this.setState({ failure: true })
      setTimeout(() => {
        this.setState({ failure: false })
      }, 3000)
    }

    render() {
      return (
        <ComposedComponent
          {...this.props}
          showFailure={this.showFailure}
          showSuccess={this.showSuccess}
          success={this.state.success}
          failure={this.state.failure}
        />
      )
    }
  }

export default withAlertTimeout



// WEBPACK FOOTER //
// ./src/HOCs/withAlertTimeout.js